import { LegHeader } from "./LegHeader";
import { UnsupportedLegCard } from "./UnsupportedLegCard";
import { UnmatchedLegCard } from "./UnmatchedLegCard";
import { CurrentMarketCard } from "./CurrentMarketCard";
import { HistoricalPerformanceCard } from "./HistoricalPerformanceCard";
import { PaScoreCard } from "./PaScoreCard";
import { PaExplanationCard } from "./PaExplanationCard";

// Per-leg orchestrator. Branches only on the two supported-flags:
//   * leg.supported === false  -> UnsupportedLegCard
//   * leg.matched !== true     -> UnmatchedLegCard (still supported)
//   * matched                  -> full 4-card stack
// This is exactly the same decision tree that shipped to production --
// do not fold the two miss cards into one branch.
export function LegBlock({ leg }) {
  if (leg.supported === false) {
    return (
      <>
        <LegHeader leg={leg} />
        <UnsupportedLegCard leg={leg} />
      </>
    );
  }
  if (leg.matched !== true) {
    return (
      <>
        <LegHeader leg={leg} />
        <UnmatchedLegCard leg={leg} />
      </>
    );
  }
  return (
    <>
      <LegHeader leg={leg} />
      <CurrentMarketCard leg={leg} />
      <HistoricalPerformanceCard
        historical={leg.historical}
        market={leg.market}
        side={leg.side}
        line={leg.user_line ?? leg.line ?? null}
      />
      <PaScoreCard paScore={leg.pa_score} />
      <PaExplanationCard leg={leg} />
    </>
  );
}
